module.exports = __webpack_public_path__ + "static/gallery3-030192e4ffc7c6f688fb74e6ad25fe9c.jpg";